import { Model } from "../lib";

export default class Country extends Model {
  urlRoot = "/countries";
  _primaryKey = "code";
}
